import React from "react";
import { ActionIcon, Alert, Button, Group, Text } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { FaCheck, FaInfoCircle } from "react-icons/fa";
import { FaXmark } from "react-icons/fa6";
import {
  selectAutoPipeRoutingConnectionPoints,
  selectAutoPipeRoutingPickingConnectionPointInViewer,
  setAutoPipeRoutingModalOpenInRedux,
  setAutoPipeRoutingConnectionPointInRedux,
  setAutoPipeRoutingPickingConnectionPointInViewerInRedux,
} from "./pipeRoutingSlice";

export const AutoPipeRoutingConnectionPointBanner: React.FC = () => {
  const dispatch = useAppDispatch();
  const pickingConnectionPointInViewer = useAppSelector(
    selectAutoPipeRoutingPickingConnectionPointInViewer
  );
  const connectionPoints = useAppSelector(selectAutoPipeRoutingConnectionPoints);

  if (!pickingConnectionPointInViewer) return null;

  const handleCancel = () => {
    dispatch(setAutoPipeRoutingConnectionPointInRedux([]));
    dispatch(setAutoPipeRoutingPickingConnectionPointInViewerInRedux(false));
    dispatch(setAutoPipeRoutingModalOpenInRedux(true));
  };

  const handleClearPoints = () => {
    dispatch(setAutoPipeRoutingConnectionPointInRedux([]));
  };

  const handleConfirm = () => {
    if (connectionPoints.length === 0) {
      return;
    }

    dispatch(setAutoPipeRoutingPickingConnectionPointInViewerInRedux(false));
    dispatch(setAutoPipeRoutingModalOpenInRedux(true));
  };

  return (
    <Alert
      variant="light"
      color="blue"
      radius="xl"
      icon={<FaInfoCircle size={16} />}
      styles={{
        root: {
          paddingTop: 10,
          paddingBottom: 10,
          paddingLeft: 14,
          paddingRight: 10,
          backgroundColor: "var(--mantine-color-blue-1)",
          border: "1px solid var(--mantine-color-blue-4)",
          boxShadow: "0 4px 18px rgba(0,0,0,0.18)",
        },
      }}
    >
      <Group justify="space-between" align="center" wrap="nowrap">
        <div>
          {connectionPoints.length === 0 && (
            <>
              <Text size="sm" fw={600} c="black">
                Velg anslutningspunkter for automatisk rordragning
              </Text>
              <Text size="xs" c="dimmed">
                Klikk på punkter der du vil at rorene skal anslutte.
              </Text>
            </>
          )}

          {connectionPoints.length > 0 && (
            <>
              <Text size="sm" fw={600} c="black">
                Du har valgt {connectionPoints.length} punkt
              </Text>
              <Text size="xs" c="dimmed">
                Klikk flere steder for å legge til flere anslutningspunkter.
              </Text>
            </>
          )}
        </div>

        {connectionPoints.length === 0 && (
          <ActionIcon
            variant="subtle"
            color="blue"
            radius="xl"
            aria-label="Avbryt valg av anslutningspunkt"
            onClick={handleCancel}
          >
            <FaXmark size={14} />
          </ActionIcon>
        )}

        {connectionPoints.length > 0 && (
          <Group gap="xs" wrap="nowrap">
            <Button variant="subtle" color="blue" onClick={handleClearPoints}>
              Tøm punkter
            </Button>
            <Button variant="subtle" color="gray" onClick={handleCancel}>
              Avbryt
            </Button>
            <ActionIcon
              variant="light"
              color="blue"
              radius="xl"
              aria-label="Bekreft valgt punkt"
              onClick={handleConfirm}
            >
              <FaCheck size={14} />
            </ActionIcon>
          </Group>
        )}
      </Group>
    </Alert>
  );
};
